export function mountTicker(root) {
	const ticker = root.querySelector(".solufy-hero__ticker");
	if (!ticker) return () => {};

	const pause = () => ticker.classList.add("is-paused");
	const resume = () => ticker.classList.remove("is-paused");

	ticker.addEventListener("mouseenter", pause);
	ticker.addEventListener("mouseleave", resume);
	ticker.addEventListener("touchstart", pause, { passive: true });
	ticker.addEventListener("touchend", resume, { passive: true });

	return () => {
		ticker.removeEventListener("mouseenter", pause);
		ticker.removeEventListener("mouseleave", resume);
		ticker.removeEventListener("touchstart", pause);
		ticker.removeEventListener("touchend", resume);
	};
}
